import moment from 'moment';
import 'moment/locale/ko';
import { useEffect, useRef, useState } from 'react';
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
    deleteMABAA030Block,
    deleteMABAA070Block,
    getMABAA030,
    getMABAA030Block,
    getMABAA070Block,
    postMABAA030Block,
    postMABAA030Comment,
    postMABAA030Comments,
    postMABAA030Leave,
    postMABAA070Block,
    postMABAA070Leave,
    putMABAA030,
    putMABAA030Bcs,
    putMABAA030ResetAuth,
    putMABAA030ResetPassword,
    putMABAA030ResetStatus,
    putMABAA030Sms,
    putMABAA030VitaminLetter,
    putMABAA070Bcs,
    putMABAA070Sms,
    putMABAA070VitaminLetter,
} from '../../../services/Api';
import FormatPhoneNumber from '../../../shared/components/FormatPhoneNumber';
import Pagination from '../../../shared/components/Pagination';
import { MESSAGE } from '../../../shared/constants/app';
import { formatBizNo, formatDate, formatDateTime, generateYearOptions, handleFocus } from '../../../utils';

const MABAA030 = () => {
    const [pages, setPages] = useState({});
    const [data, setData] = useState(() => {
        const savedData = localStorage.getItem('dataLocal');
        if (savedData) {
            try {
                const parsedData = JSON.parse(savedData);
                return parsedData;
            } catch (error) {
                console.error(error);
            }
        }
        return {};
    });
    const [isBlock, setIsBlock] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [dataComments, setDataComments] = useState([]);
    const [reasonValue, setReasonValue] = useState('');
    const { id } = useParams();
    const [isPopupVisible, setIsPopupVisile] = useState(false);
    const [isInputReason, setIsInputReason] = useState(true);
    const [payload, setPayload] = useState({});
    const [points, setPoints] = useState(0);

    const tbl = searchParams.get('tbl');
    const memberGbn = searchParams.get('gbn');

    const openPostcodePopup = useDaumPostcodePopup();

    const handleComplete = (data) => {
        const { address, zonecode: postNo, roadAddress: addressRoad, bname: addressExtra } = data;
        setData((prevData) => ({ ...prevData, postNo, addressRoad, addressExtra, address }));
    };

    const { pathname } = useLocation();
    const [residentNoDisplay, setResidentNoDisplay] = useState('');
    const pathKey = pathname.split('/')[1].split('-')[0];

    const navigator = useNavigate();

    const currentYear = moment().year();
    const yearOptions = generateYearOptions(currentYear - 100, currentYear);
    const schoolOptions = [
        { option: '서울대', value: '서울대' },
        { option: '경희대', value: '경희대' },
        { option: '연세대', value: '연세대' },
        { option: '조선대', value: '조선대' },
        { option: '경북대', value: '경북대' },
        { option: '부산대', value: '부산대' },
        { option: '전남대', value: '전남대' },
        { option: '전북대', value: '전북대' },
        { option: '원광대', value: '원광대' },
        { option: '단국대', value: '단국대' },
        { option: '강릉원주대', value: '강릉원주대' },
        { option: '기타', value: '기타' },
    ];

    const fetchData = async () => {
        try {
            let dataBlock;
            const { data: memberData } = await getMABAA030(id, tbl, memberGbn);
            const member = memberData.member;
            setData(member);
            if (member?.memberID) {
                await postMABAA030Comments(member.memberID, { size: 10, page }).then((res) => {
                    setPages(res.data?.info);
                    setDataComments(res.data?.recruitPayments);
                });
                const response = await getMABAA030Block(member.memberID);
                dataBlock = response.data;
                setIsBlock(dataBlock === '' ? 0 : 1);
            }

            if (member?.residentNo) {
                let m = moment(member.residentNo, "YYMMDD");

                if (m.isAfter(moment())) {
                    m = m.subtract(100, "years");
                }

                setResidentNoDisplay(m.format("YYYY.MM.DD"));

                setData(prev => ({
                    ...prev,
                    residentNo: m.format("YYYYMMDD")
                }));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const fetchDataCommment = async (currentPage = page) => {
        try {
            let dataBlock;
            let response;
            const { data: memberData } = await getMABAA030(id, tbl, memberGbn);
            const member = memberData.member;
            setPoints(memberData.points);
            if (member?.memberID) {
                await postMABAA030Comments(member.memberID, { size: 10, page: currentPage }).then((res) => {
                    setPages(res.data?.info);
                    setDataComments(res.data?.recruitPayments);
                });

                if (pathKey === 'MABAA030') {
                    response = await getMABAA030Block(member.memberID);
                } else {
                    response = await getMABAA070Block(member.memberID);
                }

                dataBlock = response.data;
                setIsBlock(dataBlock === '' ? 0 : 1);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [id]);

    useEffect(() => {
        fetchDataCommment();
        // eslint-disable-next-line
    }, [page]);

    const debounceTimeoutRef = useRef(null);

    useEffect(() => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(() => {
            try {
                localStorage.setItem('dataLocal', JSON.stringify(data));
            } catch (error) {
                console.error(error);
            }
        }, 300);
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, [data]);

    const handleClose = () => {
        setIsPopupVisile(false);
    };

    const handleOpen = () => {
        setIsPopupVisile(true);
        setReasonValue('');
    };

    const handleChangeReason = (e) => {
        const value = e.target.value;
        setReasonValue(value);
    };

    const handleBlock = async (memberID) => {
        if (pathKey === 'MABAA030') {
            if (isBlock) {
                await deleteMABAA030Block(memberID);
                setIsBlock(false);
                window.alert('차단 대상에 해제되었습니다.');
                return;
            } else {
                await postMABAA030Block(memberID);
                setIsBlock(true);
                window.alert('차단 대상에 등록되었습니다.');
                return;
            }
        } else {
            if (isBlock) {
                await deleteMABAA070Block(memberID);
                setIsBlock(false);
                window.alert('차단 대상에 해제되었습니다.');
                return;
            } else {
                await postMABAA070Block(memberID);
                setIsBlock(true);
                window.alert('차단 대상에 등록되었습니다.');
                return;
            }
        }
    };

    const handleSearchAddress = () => {
        openPostcodePopup({
            onComplete: handleComplete,
            popupTitle: '델탈잡 채용광고 지도',
        });
    };

    const lastLoginSite = {
        DJ: '덴탈잡',
        DA: '덴탈알바',
        DS: '덴탈세미나',
        DV: '덴탈비타민',
        EM: 'DVmall',
    };

    const handleUpdateVitaminLetter = () => {
        handleUpdate('vitaminLetter', putMABAA030VitaminLetter, putMABAA070VitaminLetter, {
            message: {
                confirmY: '덴탈비타민 메일 수신여부가 변경하시겠습니까?',
                successY: '덴탈비타민 메일 수신여부가 변경되었습니다.',
                confirmN: '덴탈비타민 메일 수신여부가 변경하시겠습니까?',
                successN: '덴탈비타민 메일 수신여부가 변경되었습니다.',
            },
        });
    };

    const handleUpdateSMSSrv = () => {
        handleUpdate('smsSrv', putMABAA030Sms, putMABAA070Sms, {
            message: {
                confirmY: 'SMS 수신여부가 변경하시겠습니까?',
                successY: 'SMS 수신여부가 변경되었습니다.',
                confirmN: 'SMS 수신여부가 변경하시겠습니까?',
                successN: 'SMS 수신여부가 변경되었습니다.',
            },
        });
    };

    const handleUpdateBcsSelYN = () => {
        handleUpdate('bcsSelYN', putMABAA030Bcs, putMABAA070Bcs, {
            message: {
                confirmN: '해당회원을 우수회원으로 선정하시겠습니까?',
                successN: '우수회원으로 선정되었습니다.',
                confirmY: '해당회원을 우수회원에서 제외시키시겠습니까?',
                successY: '우수회원에서 제외되었습니다.',
            },
        });
    };

    const handleUpdate = (field, apiCall030, apiCall070, { message }) => {
        const currentValue = data[field];
        const confirmMessage = currentValue === 'Y' ? message.confirmY : message.confirmN;
        const successMessage = currentValue === 'Y' ? message.successY : message.successN;
        const isConfirmed = window.confirm(confirmMessage);
        if (isConfirmed) {
            const apiCall = id ? apiCall030 : apiCall070;
            const payload = {
                seq: id,
                [field]: currentValue === 'Y' ? 'N' : 'Y',
            };
            apiCall(payload[field], id)
                .then(() => {
                    window.alert(successMessage);
                    setData((prevData) => ({
                        ...prevData,
                        [field]: payload[field],
                    }));
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        let processedValue;

        if (name === 'mobileNo' || name === 'telNo') {
            processedValue = FormatPhoneNumber(value);
        } else if (name === 'bizNo') {
            processedValue = formatBizNo(value);
        } else if (name === 'residentNo') {
            const onlyNumber = value.replace(/[^\d]/g, '');

            let formatted = onlyNumber;
            if (onlyNumber.length >= 8) {
                formatted = `${onlyNumber.slice(0, 4)}.${onlyNumber.slice(4, 6)}.${onlyNumber.slice(6, 8)}`;
            }

            setResidentNoDisplay(formatted);
            setData(prev => ({
                ...prev,
                residentNo: onlyNumber.slice(0, 8) // YYYYMMDD
            }));
            return;
        } else {
            processedValue = value;
        }

        setData((prevData) => ({
            ...prevData,
            [name]: processedValue,
        }));
    };
    const handleSaveLeave = () => {
        const dataLeave = {
            memberID: data.memberID,
            leaveSite: data.lastLoginSite,
            leaveReason: reasonValue,
            leaveType: 'ADMIN',
        };
        const isConfirmed = id ? window.confirm(MESSAGE.confirm.create) : '';
        if (isConfirmed) {
            if (pathKey === 'MABAA030') {
                postMABAA030Leave(dataLeave);
            } else {
                postMABAA070Leave(dataLeave);
            }
            window.alert(MESSAGE.notify.createSuccess);
            setIsInputReason(false);
        }
    };
    const handleSave = () => {
        if (data.appGbnCD === '110' && data.licenseNo === '') {
            alert('회원구분이 치과의사인 경우 면허번호는 필수항목입니다.\n면허/자격증번호를 올바르게 입력해 주세요.');
            handleFocus('licenseNo');
            return;
        }
        // if (
        //     ((pathKey === 'mabaa070' || pathKey === 'mabaa072') && data.appGbnCD === '110' && data.school === '') ||
        //     ((pathKey === 'mabaa070' || pathKey === 'mabaa072') && data.school === '기타' && data.schoolEtc === '') ||
        //     ((pathKey === 'mabaa070' || pathKey === 'mabaa072') && data.appGbnCD === '110' && data.graduateYear === '')
        // ) {
        //     alert('학교정보를 빠짐없이 입력해 주세요.');
        //     if (data.school === '기타' && data.schoolEtc === '') {
        //         handleFocus('schoolEtc');
        //     } else {
        //         handleFocus('school');
        //     }
        //     return;
        // }
        if ((pathKey === 'mabaa070' || pathKey === 'mabaa072') && data.memberGbn === 'P') {
            data.school = '';
            data.graduateYear = '';
            data.schoolEtc = '';
        }

        const payload = {
            seq: id,
            nameKor: data.nameKor,
            bizCompany: data.bizCompany,
            postNo: data.postNo,
            addressRoad: data.addressRoad,
            addressDetail: data.addressDetail,
            email: data.email,
            mobileNo: data.mobileNo,
            telNo: data.telNo,
            memberGbn: data.memberGbn,
            appGbnCD: data.appGbnCD,
            bizNo: data.appGbnCD !== '110' && (pathKey === 'mabaa070' || pathKey === 'mabaa072') ? '' : data.bizNo,
            licenseNo: data.licenseNo,
            school: data.appGbnCD === '110' ? data.school : '',
            graduateYear: data.appGbnCD === '110' ? data.graduateYear : '',
            schoolEtc: data.appGbnCD === '110' ? data.schoolEtc : '',
            residentNo: data.residentNo
                ? moment(data.residentNo, 'YYYYMMDD').format('YYMMDD')
                : '',
            tbl,
        };

        if (window.confirm('저장하시겠습니까?')) {
            putMABAA030(payload)
                .then(() => {
                    window.alert('업데이트 완료되었습니다.');
                    setData((prevData) => ({
                        ...prevData,
                        ...payload,
                    }));
                    data.memberGbn === 'P'
                        ? navigator(`/mabaa030-${id}?tbl=${tbl}&gbn=${data.memberGbn}`)
                        : navigator(`/mabaa070-${id}?tbl=${tbl}&gbn=${data.memberGbn}`);
                })
                .catch((error) => {
                    console.log(error);
                    window.alert('오류발생했습니다.');
                });
        }
    };

    const handleResetPassword = () => {
        if (window.confirm('비밀번호 초기화하시겠습니까?')) {
            putMABAA030ResetPassword(data?.seq, tbl)
                .then(() => {
                    window.alert('비밀번호를 아이디와 동일하게 초기화되었습니다.');
                })
                .catch((error) => console.log(error));
        }
    };

    const handleResetAuth = () => {
        putMABAA030ResetAuth(data?.seq, tbl)
            .then((res) => {
                if (res?.data) {
                    window.alert('2차 비밀번호가 삭제되었습니다.');
                } else {
                    window.alert('2차 비밀번호가 설정되어 있지 않습니다.');
                }
            })
            .catch((error) => console.log(error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPayload((prevPayload) => ({
            ...prevPayload,
            [name]: value,
        }));
    };

    const handleSaveComment = () => {
        if (!payload.comments) {
            alert('코멘트 내용을 입력해 주세요.');
            handleFocus('comments');
            return;
        }

        payload.memberID = data.memberID;
        payload.sitePos = 'DJ';

        postMABAA030Comment(payload)
            .then(() => {
                setPayload((prev) => ({
                    ...prev,
                    comments: '',
                }));
                alert('코멘트 등록되었습니다.');
                const updatedParams = new URLSearchParams(searchParams);
                updatedParams.set('page', 1);
                setSearchParams(updatedParams);
                fetchDataCommment(1);
            })
            .catch((error) => console.log(error));
    };
    function getSiteNameSwitch(regSiteGbn) {
        switch (regSiteGbn) {
            case 'DJ':
                return '덴탈잡';
            case 'DS':
                return '덴탈세미나';
            case 'DV':
                return '덴탈비타민';
            case 'EM':
                return 'DVmall';
            default:
                return regSiteGbn;
        }
    }
    const handleResetStatus = () => {
        console.log(data);

        const confirm = window.confirm(`휴면계정을 활성계정으로 전환하시겠습니까?`);
        if (confirm) {
            putMABAA030ResetStatus(data?.seq)
                .then(() => {
                    window.alert('활성전환이 완료되었습니다.');
                    window.location.reload();
                })
                .catch((error) => {
                    window.alert('오류 발생했습니다.');
                    console.log(error);
                });
        }
    };
    return (
        <div className="profile-content">
            <div className="title-profile">회원 기본정보</div>
            <div className="group-action">
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '3px',
                    }}
                >
                    <button className="action-block" onClick={() => handleBlock(data.memberID)}>
                        {isBlock ? '차단해제' : '차단등록'}
                    </button>
                    {isBlock ? <div style={{ color: 'red', fontWeight: 'bold' }}>(차단중)</div> : ''}
                </div>
                <button className="action-reason" onClick={() => handleOpen()}>
                    탈퇴
                </button>
            </div>

            <div className="member-basic-infor">
                <div className="title-table-info">개인 정보</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th>
                                <span>회원상태</span>
                            </th>
                            <td className="border-r-ddd">
                                {data.memberStatus !== '' ? '활성' : '휴면'}
                                {data.memberStatus === '' && (
                                    <button
                                        className="pick-address"
                                        style={{ marginLeft: '18px' }}
                                        onClick={handleResetStatus}
                                    >
                                        휴면계정 활성전환(ID 통합 아님)
                                    </button>
                                )}
                            </td>
                            <th colSpan={2}>
                                <span>가입일</span>
                            </th>
                            <td>{formatDate(data.regDate)}</td>
                        </tr>
                        <tr>
                            <th>
                                <span>아이디</span>
                            </th>
                            <td className="border-r-ddd">{data.memberID}</td>
                            <th colSpan={2}>
                                <span>비밀번호</span>
                            </th>
                            <td>
                                <button className="btn btn-secondary" onClick={handleResetPassword}>
                                    아이디와 동일하게 초기화
                                </button>
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>
                                    이름
                                    {(pathKey === 'mabaa070' || pathKey === 'mabaa072') && '(대표자명)'}

                                </span>
                            </th>
                            <td className="border-r-ddd">
                                <input onChange={handleChange} type="text" name="nameKor" value={data.nameKor || ''} />
                            </td>
                            <th colSpan={2} className="border-t-ddd">
                                <span>생년월일</span>
                            </th>
                            <td className="border-t-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="residentNo"
                                    value={residentNoDisplay}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th rowSpan={3} style={{ verticalAlign: 'middle' }}>
                                <span>주소</span>
                            </th>
                            <td className="border-r-ddd">
                                <span style={{ marginRight: '15px' }}>
                                    ({' '}
                                    <input
                                        onChange={handleChange}
                                        type="text"
                                        name="postNo"
                                        value={data.postNo || ''}
                                        style={{ width: '80px' }}
                                        readOnly
                                    />{' '}
                                    )
                                </span>
                                <button className="pick-address" onClick={handleSearchAddress}>
                                    주소변경
                                </button>
                            </td>
                            <th colSpan={2}>
                                <span>이메일</span>
                            </th>
                            <td>
                                <input onChange={handleChange} type="text" name="email" value={data.email || ''} />
                            </td>
                        </tr>
                        <tr>
                            <td className="border-r-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="addressRoad"
                                    value={data.addressRoad || ''}
                                    readOnly
                                />
                            </td>
                            <th colSpan={1} rowSpan={2} style={{ width: '80px', verticalAlign: 'middle' }}>
                                <span>연락처</span>
                            </th>
                            <th colSpan={1} rowSpan={1} style={{ width: '80px' }}>
                                유선
                            </th>
                            <td>
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="telNo"
                                    value={FormatPhoneNumber(data.telNo) || ''}
                                    maxLength={13}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="border-r-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="addressDetail"
                                    value={data.addressDetail || ''}
                                />
                            </td>
                            <th colSpan={1} rowSpan={1} style={{ width: '80px' }}>
                                휴대폰
                            </th>
                            <td>
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="mobileNo"
                                    value={data.mobileNo || ''}
                                    maxLength={13}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>회원구분</span>
                            </th>
                            <td className="border-r-ddd">
                                <select name="appGbnCD" value={data.appGbnCD || ''} onChange={handleChange}>
                                    <option value="110">치과의사</option>
                                    <option value="200">치과기공사</option>
                                    <option value="201">치과기공사(소장)</option>
                                    <option value="202">치과기공사(기사)</option>
                                    <option value="310">치과위생사 및 진료스텝</option>
                                    <option value="401">학생(치의학과)</option>
                                    <option value="402">학생(치위생사)</option>
                                    <option value="403">학생(치기공사)</option>
                                    <option value="999">기타</option>
                                </select>
                            </td>
                            <th colSpan={2}>
                                <span>근무처(사업자명)</span>
                            </th>
                            <td>
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="bizCompany"
                                    value={data.bizCompany || ''}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <span>면허번호</span>
                            </th>
                            <td className="border-r-ddd border-b-ddd">
                                <input
                                    onChange={handleChange}
                                    type="text"
                                    name="licenseNo"
                                    value={data.licenseNo || ''}
                                />
                            </td>
                            <th colSpan={2}>
                                <span>덴탈잡그룹구분</span>
                            </th>
                            <td className="border-b-ddd">
                                <select name="memberGbn" value={data.memberGbn || ''} onChange={handleChange}>
                                    <option value="P">개인회원</option>
                                    <option value="C">치과회원</option>
                                </select>
                            </td>
                        </tr>
                        {(pathKey === 'mabaa070' || pathKey === 'mabaa072') && (
                            <tr>
                                <th>
                                    <span>사업자번호</span>
                                </th>
                                <td className="border-r-ddd border-b-ddd">
                                    <input
                                        onChange={handleChange}
                                        type="text"
                                        name="bizNo"
                                        value={formatBizNo(data.bizNo) || ''}
                                        maxLength={12}
                                    />
                                </td>
                                <th colSpan={2}>
                                    <span>2차 인증 비밀번호</span>
                                </th>
                                <td className="border-b-ddd">
                                    <button className="pick-address" onClick={handleResetAuth}>
                                        2차 인증 비밀번호 삭제
                                    </button>
                                </td>
                            </tr>
                        )}
                        {data.appGbnCD === '110' && (pathKey === 'mabaa070' || pathKey === 'mabaa072') && (
                            <tr>
                                <th>
                                    <span>학교 정보</span>
                                </th>
                                <td className="d-flex align-items-center gap-2 border-bottom-0">
                                    <select name="school" value={data.school || ''} onChange={handleChange}>
                                        <option value="">졸업 학교 선택</option>
                                        {schoolOptions.map((school, index) => (
                                            <option key={'school' + index} value={school.value}>
                                                {school.option}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="text"
                                        name="schoolEtc"
                                        value={data.schoolEtc || ''}
                                        onChange={handleChange}
                                        placeholder="직접 입력"
                                        style={{ width: '200px' }}
                                        disabled={data.school !== '기타'}
                                    />
                                    <span style={{ whiteSpace: 'nowrap' }}>졸업 연도:</span>
                                    <select name="graduateYear" value={data.graduateYear || ''} onChange={handleChange}>
                                        <option value="">졸업 연도 선택</option>
                                        {yearOptions.map((year, index) => (
                                            <option key={'graduateYear' + index} value={year.value}>
                                                {year.option}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <div className="membership-infor">
                <div className="title-table-info">멤버십 정보</div>
                <table className="table member-infor">
                    {/* <tbody>
                        <tr>
                            <th className="border-t-ddd">
                                <span>통합여부</span>
                            </th>
                            <td colSpan={3}>
                                통합회원
                            </td>
                        </tr>
                        <tr>
                            <th className="border-t-ddd">
                                <span>가입사이트</span>
                            </th>
                            <td className="border-r-ddd">{getSiteNameSwitch(data?.regSiteGbn) || '-'}</td>
                            <th className="border-t-ddd" style={{ width: '163px' }}>
                                이용가능 사이트
                            </th>
                            <td>덴탈알바, 덴탈잡, 덴탈세미나, 덴탈비타민, DVmall</td>
                        </tr>
                        <tr>
                            <th>Dvmall ID</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th style={{ width: '200px' }}>DVmall 인증 DV ID</th>
                            <td colSpan={3}></td>
                        </tr>
                        <tr>
                            <th>덴탈비타민 ID</th>
                            <td colSpan={3}>{data?.memberID}</td>
                        </tr>
                        <tr>
                            <th>보유 DV Point</th>
                            <td colSpan={3}>{data?.availablePoints}</td>
                        </tr>
                    </tbody> */}
                    <tbody>
                        <tr>
                            <th className="border-t-ddd">
                                <span>통합여부</span>
                            </th>
                            <td className="border-r-ddd">
                                {/* {data.memberStatus === 'INTL' ? '통합 회원' : '미통합 회원'} */}
                                통합 회원
                            </td>
                            <th className="border-t-ddd">
                                <span>DVmall</span>
                            </th>
                            <td>{data.emJoinMembership === 0 ? '비회원' : '회원'}</td>
                        </tr>
                        <tr>
                            <th className="border-t-ddd">
                                <span>가입사이트</span>
                            </th>
                            <td className="border-r-ddd">{getSiteNameSwitch(data.regSiteGbn) || '-'}</td>
                            <th className="border-t-ddd">
                                <span>덴트웹</span>
                            </th>
                            <td>비회원</td>
                        </tr>
                        <tr>
                            <th>
                                <span>최초 가입일</span>
                            </th>
                            <td className="border-r-ddd">{formatDateTime(data.regDate)}</td>
                            <th>
                                <span>보유 DV Point</span>
                            </th>
                            <td>{points}</td>
                        </tr>
                        <tr>
                            <th>
                                <span>최종 수정일</span>
                            </th>
                            <td className="border-r-ddd border-b-ddd">{formatDateTime(data.modDate)}</td>
                            <th>
                                <span>최종 로그인</span>
                            </th>
                            <td className="border-b-ddd">
                                {(lastLoginSite[data.lastLoginSite] || '') + ' ' + formatDateTime(data.lastLoginDate)}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="receive-infor">
                <div className="title-table-info">정보 수신</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th className="border-t-ddd border-b-ddd">
                                <span>덴탈비타민</span>
                            </th>
                            <td className="border-r-ddd border-b-ddd border-l-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="vitaminLetter"
                                        id="vitaminLetter"
                                        checked={data.vitaminLetter === 'Y'}
                                        onChange={handleUpdateVitaminLetter}
                                    />
                                </div>
                            </td>
                            <th className="border-t-ddd border-b-ddd">
                                <span>SMS</span>
                            </th>
                            <td className="border-b-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="smsSrv"
                                        id="smsSrv"
                                        checked={data.smsSrv === 'Y'}
                                        onChange={handleUpdateSMSSrv}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="for-member-only">
                <div className="title-table-info">회원 대상</div>
                <table className="table member-infor">
                    <tbody>
                        <tr>
                            <th className="border-t-ddd border-b-ddd">
                                <span>우수회원선정</span>
                            </th>
                            <td colSpan={2} className="border-b-ddd">
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        name="bcsSelYN"
                                        id="bcsSelYN"
                                        checked={data.bcsSelYN === 'Y'}
                                        onChange={handleUpdateBcsSelYN}
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div
                className="bottom-content"
                style={{
                    borderTop: 'unset',
                    borderBottom: '1px solid #999999',
                    paddingBottom: '20px',
                }}
            >
                <div className="button-form">
                    <Link to={'/mabaa010'} className="btn btn-primary button-back-to-list">
                        목록
                    </Link>
                </div>
                <div className="button-form">
                    <button className="btn btn-primary" onClick={handleSave}>
                        저장
                    </button>
                </div>
            </div>
            <div className="comments-member">
                <label htmlFor="commentArea" className="form-label">
                    <div className="title-table-info">코멘트</div>
                </label>
                <textarea
                    placeholder="내용을 입력하세요."
                    className="form-control"
                    id="commentArea"
                    rows={3}
                    name="comments"
                    value={payload?.comments || ''}
                    onChange={handleInputChange}
                />
            </div>
            <div className="button-form" style={{ marginTop: '20px' }}>
                <button className="btn btn-primary" onClick={handleSaveComment}>
                    추가
                </button>
            </div>
            <div id="infomation-member">
                <label htmlFor="textarea1" className="form-label">
                    <div className="title-table-info">코멘트 리스트</div>
                </label>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>일자</th>
                            <th>관리자</th>
                            <th>내용</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataComments && dataComments.length > 0 ? (
                            dataComments.map((item, index) => (
                                <tr key={'comment' + index}>
                                    <td>{formatDate(item?.addDate)}</td>
                                    <td>{item?.adminName}</td>
                                    <td>{item?.comments}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td style={{ textAlign: 'center' }} colSpan={3}>
                                    데이타가 없습니다.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <Pagination pages={pages} />
            </div>
            {isPopupVisible && (
                <div id="popup" className="reason-popup">
                    <div className="overlay" onClick={handleClose} />
                    {isInputReason && (
                        <div className="popup-content">
                            <div className="popup-close" onClick={handleClose} />
                            <div className="popup-title">탈퇴사유</div>
                            <textarea className="reason" onChange={handleChangeReason} value={reasonValue}></textarea>
                            <div className="groupButton">
                                <Link to={'/mabaa010'} className="popup-button" onClick={handleSaveLeave}>
                                    탈퇴
                                </Link>
                                <Link className="popup-button" onClick={handleClose}>
                                    취소
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MABAA030;
